import React from "react";
import { ICoupon } from "repoV2/features/CheckoutPages/utils/apis/LoyaltyAndPromoDetailsApi/ILoyaltyDiscountSectionApi.interface";
import { IAppliedCouponCodeDetails } from "repoV2/features/Common/modules/FormData/interfaces/IAppliedCouponCodeDetails";
import { FORM_KEYS } from "repoV2/features/Common/modules/FormData/FormData.constants";
import { useCheckoutBasicDetailsContext } from "repoV2/features/CheckoutPages/modules/CheckoutBasicDetailsContextProvider";
import useGetFormData from "repoV2/features/Common/modules/FormData/utils/useGetFormData";
import Coupon from "../Coupon/Coupon";
import { deafult_applied_coupon_code_details } from "../../CouponCodeFormGroup.utils";
import { COUPON_TYPES } from "../../CouponCodeFormGroup.constants";

const PromotionOffer = ({
    promotionalCoupons,
    currency,
    onApplyCouponCodeClick,
}: {
    promotionalCoupons: ICoupon[];
    currency: string;
    onApplyCouponCodeClick: ({
        couponType,
        code,
    }: {
        couponType?: number | undefined;
        code?: string | undefined;
    }) => void;
}) => {
    const { listingUuid } = useCheckoutBasicDetailsContext();
    const appliedCouponCodeData =
        useGetFormData<IAppliedCouponCodeDetails>({
            key: `${FORM_KEYS.listing_details}.${listingUuid}.${FORM_KEYS.applied_coupon_code_details}`,
        }) || deafult_applied_coupon_code_details;

    return (
        <div>
            {promotionalCoupons.map(promotional_coupon => {
                const {
                    code,
                    value,
                    expiry,
                    type,
                    promotional_data: { description = "" },
                } = promotional_coupon;
                return (
                    <Coupon
                        key={code}
                        code={code}
                        value={value}
                        expiry={expiry}
                        type={type}
                        currency={currency}
                        couponType={COUPON_TYPES.PROMOTIONAL_COUPON}
                        appliedCouponCodeValue={
                            appliedCouponCodeData.couponCode || ""
                        }
                        onApplyCouponCodeClick={onApplyCouponCodeClick}
                        description={description}
                    />
                );
            })}
        </div>
    );
};

export default PromotionOffer;
